export enum SelectorChangeabilityEnum {
	NO_RESTRICTIONS = '0', // ignore
	CHANGE_OTHERS_RIGHTS = '1', // ignore: muss backend steuern
	NO_DESELECTION = '2',
}
